var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.TEXT.title } }),
      _c("div", { staticClass: "step-wizard-container" }, [
        _c("h2", { staticClass: "step-title" }, [
          _vm._v(_vm._s(_setup.TEXT.importFinished)),
        ]),
        _c("div", { staticClass: "statistics-container" }, [
          _c("div", { staticClass: "statistics-row" }, [
            _c(
              "div",
              { staticClass: "statistic-card statistic-card--success" },
              [
                _c("div", { staticClass: "statistic-content" }, [
                  _c("div", { staticClass: "statistic-label" }, [
                    _vm._v(_vm._s(_setup.TEXT.createdRecords)),
                  ]),
                  _c("div", { staticClass: "statistic-number" }, [
                    _vm._v(
                      _vm._s(
                        _setup.importExpedientsProcessStore.importSummary
                          ?.successCount ?? 0
                      )
                    ),
                  ]),
                ]),
              ]
            ),
            _c("div", { staticClass: "statistic-card statistic-card--error" }, [
              _c("div", { staticClass: "statistic-content" }, [
                _c("div", { staticClass: "statistic-label" }, [
                  _vm._v(_vm._s(_setup.TEXT.errorRecords)),
                ]),
                _c("div", { staticClass: "statistic-number" }, [
                  _vm._v(
                    _vm._s(
                      _setup.importExpedientsProcessStore.importSummary
                        ?.failureCount ?? 0
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _setup.showFailureLink
          ? _c("div", { staticClass: "info-message" }, [
              _c("p", { staticClass: "info-text" }, [
                _vm._v(" " + _vm._s(_setup.TEXT.failedInfo) + " "),
              ]),
              _c(
                "a",
                {
                  staticClass: "download-link",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _setup.onExecuteAction(_setup.ActionName.DOWNLOAD)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_setup.TEXT.downloadFailedRecords) + " ")]
              ),
            ])
          : _setup.showTecnicalError
          ? _c("div", { staticClass: "info-message" }, [
              _c("div", { staticClass: "error-alert-container" }, [
                _c("img", {
                  staticClass: "error-icon",
                  attrs: {
                    src: require("@/assets/images/svg/icon-close-rounded.svg"),
                    alt: "Error icon",
                  },
                }),
                _c("div", { staticClass: "error-message" }, [
                  _vm._v(" " + _vm._s(_setup.TEXT.technicalError) + " "),
                ]),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "dialog-actions-container" },
          [
            _c(_setup.LfActionsBarComponent, {
              staticClass: "action-buttons",
              attrs: { buttons: _setup.buttons, showKebabMenu: false },
              on: { "execute-action": _setup.onExecuteAction },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }